

const App = {
  setup() {
    let collectionMediaData = [];
    if (collectionMedia != '' && collectionMedia.length > 0) {
      let tmpMedia = {
        webImgae: '',
        mobileImage: '',
        videoSrc: '',
      };

      collectionMedia.map((data, index) => {
        let operationNum = index + 1;

        if (operationNum % 3 == 1) {
          tmpMedia.webImgae = data;
        }
        if (operationNum % 3 == 2) {
          tmpMedia.mobileImage = data;
        } else if (operationNum % 3 == 0) {
          tmpMedia.videoSrc = data.sources[1].url;
        }

        if (operationNum == collectionMedia.length || operationNum % 3 == 0) {
          collectionMediaData.push(tmpMedia);
        }
      });
    }
    let topSSS = 0;
    let rect = '';
    let scrollY = 0;

    onMounted(() => {
      window.addEventListener("load", function(){
        rect  = document.getElementsByClassName('chose-list-options')[0].getBoundingClientRect()
        scrollY = window.scrollY || document.documentElement.scrollTop;

        topSSS  = rect.top+scrollY > topSSS ? rect.top+scrollY : topSSS
      })
    })
    onUnmounted(() => {
      window.removeEventListener("load", function(){
        rect  = document.getElementsByClassName('chose-list-options')[0].getBoundingClientRect()
        topSSS  = rect.top
      });
    })
    const pageLengthList = ref([16,28,48]);
    const sortByList = ref([
      {key: 4, label: "Recommended"},
      {key: 1, label: "New Products"},
      {key: 2, label: "Price High to Low"},
      {key: 3, label: "Price Low to High"},
    ]);
    const drawerState = reactive({
      filter: false,
      sortBy: false,
      size: 0,
    });
    const videoDialog = reactive({
      showState: false,
      videoSrc: "",
      size: 0,
    });
    const pageParams = reactive({
      collection_id: CollectionId,
      filter_category_id: 0,
      filter: [],
      vendor: [],
      activity: [],
      page: 1,
      pageSize: 16,
      sortBy: 4,
      priceRange: [0, 0],
      priceRangeFirst: [0, 0],
      ep_id: 0,
    });
    const goPageNumber = ref('');
    const selectFilter = reactive([]);
    const priceRange = ref([]);
    const priceRangeFirst = ref([]);
    const selectedItem = ref([]);
    const selectedCount = reactive({
      filter: {},
      vendor: {},
    });
    const vendorData = ref([]);
    const first_request = ref(1);
    const productData = reactive({
      showStyle: 1,
      total: 0,
      list: [],
      loading: false,
    });
    const filterData = ref([]);
    const categoryData = reactive({});
    const activityData = reactive({});
    const categoryMenu = ref([]);
    const vehicleData = ref([]);
    const choicePrice = (minPrice, maxPrice) => {
      pageParams.priceRange[0] = minPrice;
      pageParams.priceRange[1] = maxPrice;
      priceRangeFirst.value[0] = minPrice;
      priceRangeFirst.value[1] = maxPrice;
      if (maxPrice === 0) {
        priceRangeFirst.value[1] = "";
      }
    };

    const choiceVariants = (variantId, productIndex) => {
      productData.list[productIndex]["default"] = productData.list[productIndex]["variants"].find(
        (item) => item["variant_id"] === variantId
      );
    };

    const params = reactive({
      filter: [],
      vendor: [],
      price_range: {
        min: 0,
        max: 0,
      },
      is_new: 1,
    });
    const isUrlFromSearch = ref(false);
    const YMM = getDefaultVehicle()
    const urlRequestParams = ref('');
    const formatParams = (vehicle) => {
      if(pageParams.activity.length === 0 && requestParams.is_activity)
      {
        pageParams.activity.push(requestParams.is_activity);
        selectFilter.push({'id':1, 'options':'activity', 'name':'Clearance Event Products', 'type':'activity'})
        requestParams.is_activity = 0
      }

      let year  = requestParams.year  ? requestParams.year  : YMM.year;
      let make  = requestParams.make  ? requestParams.make  : YMM.make;
      let model = requestParams.model ? requestParams.model : YMM.model;
      let is_activity = pageParams.activity[0] ? pageParams.activity[0] : 0;
      if(year || make || model) {
        isUrlFromSearch.value = true;
        urlRequestParams.value = '?year='+year+'&make='+make+'&model='+model;
      }
      params.first_request = first_request.value;
      params.page = pageParams.page;
      params.page_size = pageParams.pageSize;
      params.sortBy = pageParams.sortBy;
      params.price_range["min"] = pageParams.priceRange[0];
      params.price_range["max"] = pageParams.priceRange[1];
      //params.filter_category_id = pageParams.filter_category_id;
      params.collection_id = pageParams.collection_id;
      params.is_activity = is_activity;

      params.filter = JSON.parse(JSON.stringify(pageParams.filter));
      params.vendor = JSON.parse(JSON.stringify(pageParams.vendor));

      if (vehicle) {
        params.year = vehicle.year;
        params.make = vehicle.make;
        params.model = vehicle.model;
      } else {
        params.year = requestParams.year ? requestParams.year : YMM.year;
        params.make = requestParams.make ? requestParams.make : YMM.make;
        params.model = requestParams.model ? requestParams.model : YMM.model;
      }

      if(pageParams.ep_id) {
        params.ep_id = pageParams.ep_id
      }else {
        // if(isUrlFromSearch.value)
        // {
        //   params.ep_id = window.localStorage.getItem('associativeEpidCookie');
        // }
        // else if (myGarageLocal.value.length > 0)
        // {
        //   params.ep_id = myGarageLocal.value[0]['epid'];
        // }
        // else
        // {
        //   params.ep_id = '';
        // }
      }
    };

    window.restFilter = (epid) => {
      pageParams.priceRange = [];
      pageParams.filter = [];
      pageParams.vendor = [];
      pageParams.ep_id = epid;
      selectedCount.filter = [];
      selectedCount.vendor = [];
      first_request.value = 1;
    };
    const isShowButton = ref(true);
    const showAllCategories = ref(true);
    const getList = (vehicle) => {
      if (vehicle && vehicle.vehicleSelect) {
        first_request.value = 1;
      }
      vehicleData.value = vehicle;
      formatParams(vehicle);

      productData.loading = true;

      axios({
        method: "post",
        url: API_HOST+"/products/list",
        data: params,
        // withCredentials: true,
      })
        .then((result) => {
          productData.total = result.data["total"];
          productData.list = result.data["products"];
          showAllCategories.value = result.data["category_list"].length <= 8

          if(isMobile())
          {
            isShowButton.value = result.data["category_list"].length > 12
          }
          else
          {
            isShowButton.value = result.data["category_list"].length > 16
          }

          //判断是否为brands顶级
          if(result.data["is_brand"])
          {
            $('#vehicle-container .vehicle-container .vehicle-title').text('Shop '+result.data["category_name"]+' Products By Vehicle');
          }

          if (result.data["filter"].length > 0)
          {
            if(result.data["filter"].length === 1 && result.data["filter"][0].length === 1)
            {
              filterData.value  = [];
            }
            else
            {
              filterData.value = result.data["filter"];
            }
          }

          if (result.data["vendor"].length > 1 || (result.data["vendor"].length > 0 && (params['collection_id'] === 297718579365 || params['collection_id'] === 298995712165)))
          {
            vendorData.value = result.data["vendor"];
          }

          if (result.data["category_list"].length > 0) {
            categoryData.category_list = result.data["category_list"];
          }

          if (result.data["product_type"].length > 0)
          {
            categoryData.product_type = result.data["product_type"];
          }

          if (result.data["activity"].length > 0)
          {
            activityData.list = result.data["activity"];
          }

          if (result.data["price_range"])
          {
            priceRange.value[0] = result.data["price_range"]["min"];
            priceRange.value[1] = result.data["price_range"]["max"];
          }

          if(params.first_request)
          {
            productData.showStyle = result.data['template'] === 'card' ? 1 : 2;
          }

          //当有ymm 的时候才会自动滚动置顶ymm
          if(!first_request.value)
          {
            if(topSSS == 0)
            {
              $("html,body").animate({
                scrollTop: 0
              }, 500);
            }
            else
            {
              if(scrollY != 0)
              {
                $("html,body").animate({
                  scrollTop: topSSS - (isMobile() ? 65 : 30)
                }, 500);
              }
              else
              {
                $("html,body").animate({
                  scrollTop: topSSS - (isMobile() ? 65 : 70)
                }, 500);
              }
            }
          }
          first_request.value = 0;
          productData.loading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    };

    //选中/取消 筛选项
    const operateFilterItem = (setItem) => {
      let addNewFilter = true;

      for(let key = 0; key < selectFilter.length; key++)
      {
        let selectTmp = selectFilter[key];

        if(selectTmp.type !== setItem.type || selectTmp.options !== setItem.options)
        {
          continue;
        }

        if(selectTmp.id === setItem.id)
        {
          addNewFilter = false;
          selectFilter.splice(key, 1);
        }

        if(!setItem.multiple && addNewFilter === true)
        {
          selectFilter.splice(key, 1);
        }
      }

      if(addNewFilter)
      {
        selectFilter.push(setItem)
      }

      let tmpData = [];
      selectFilter.map((data) => {
        if (data.type === setItem.type) {
          tmpData.push(data.id);
        }
      });
      pageParams[setItem['type']] = JSON.parse(JSON.stringify(tmpData));
    };

    const checkItemSelect = (itemType, itemId) => {
      let selectData  = selectFilter['filter'][itemType] ?? null;

      if(!selectData)
      {
        return false;
      }

      return (selectData.constructor === Array && selectData.indexOf(itemId) > -1) || selectData === itemId;
    }
    getList();

    watch(
      pageParams,
      () => {
        getList(vehicleData.value);
      },
      {deep: true}
    );

    const choiceCategory = (data) => {
      pageParams.filter_category_id = data.category_id;
      window.restFilter();
      first_request.value = 1;
    };

    const showVideo = (videoSrc) => {
      if (videoSrc === '') {
        return;
      }
      videoDialog.videoSrc = videoSrc;
      videoDialog.showState = true;
      if (document.documentElement.clientWidth <= 600) {
        videoDialog.size = '80%';
      } else {
        videoDialog.size = '50%';
      }
    };

    const setDrawerSize = () => {
      if (document.documentElement.clientWidth <= 600) {
        drawerState.size = '80%';
      } else {
        drawerState.size = '50%';
      }
    }

    const getClassBasedOnValue = (num) => {
      if(isMobile())
      {
        if(num <= 3)
        {
          return 'top-menu-list-8'
        }
        else
        {
          return 'top-menu-list-none'
        }
      }
      else
      {
        if(num <= 8)
        {
          return 'top-menu-list-8'
        }
        else
        {
          return 'top-menu-list-none'
        }
      }
    }
    const getVendorStyleBasedOnValue = (vendorName) => {
      if(vendorName == 'AVS')
      {
        return 'verticalAlign';
      }
      else
      {
        return '';
      }
    }
    const toggleRowsCategories = () => {
      showAllCategories.value = !showAllCategories.value;
    }
    // 计算属性来检查当前是否是移动端
    const isMobile = ()=> {
      // 使用正则表达式来匹配常见的移动端用户代理
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // 方法来根据索引和设备类型返回是否应该显示列表项
    const isItemVisible = (index) => {
      if (isMobile()) {
        return showAllCategories.value || index < 12;
      }
      // 否则，如果启用了显示所有类别或索引小于8，则显示
      return showAllCategories.value || index < 16;
    };
    const isShowSeeMoreAndLess = () => {
      return isShowButton.value;
    }
    const goToPage = () => {
      let goNumber = parseInt(goPageNumber.value);

      let maxPage = Math.ceil(productData.total/pageParams.pageSize);
      if(goNumber < 1 || isNaN(goNumber))
      {
        goNumber = 1;
      }
      else if(goNumber > maxPage)
      {
        goNumber = maxPage;
      }

      pageParams.page = goNumber;
    }
    return {
      goToPage,
      goPageNumber,
      checkItemSelect,
      selectFilter,
      collectionMediaData,
      setDrawerSize,
      showVideo,
      videoDialog,
      productData,
      categoryData,
      activityData,
      filterData,
      pageParams,
      operateFilterItem,
      selectedItem,
      vendorData,
      first_request,
      choiceVariants,
      priceRange,
      choicePrice,
      priceRangeFirst,
      choiceCategory,
      drawerState,
      selectedCount,
      sortByList,
      isUrlFromSearch,
      urlRequestParams,
      pageLengthList,
      restFilter,
      getClassBasedOnValue,
      getVendorStyleBasedOnValue,
      showAllCategories,
      toggleRowsCategories,
      isItemVisible,
      isShowSeeMoreAndLess,
      getList
      // AutoSelectYmm
    };
  },
};
 window.Pages['Collections'] = Vue.createApp(App).use(ElementPlus).mount("#list-page");

$(document).ready(function () {
  let isPhone = isMobile();

  if($('.top-menu-intro-long-desc .top-menu-intro-view-more').length > 0) {
    $('.top-menu-intro-view-more-button').show();
  }else {
    $('.top-menu-intro-view-more-button').hide();
  }
});
function contractFilter(thisObj) {
  let content = thisObj.next();
  let contentHeight = content.height();
  let arrow = thisObj.find(".filter-item-arrow");

  if (contentHeight > 0) {
    content.animate({height: "0px",marginBottom: "0px"}, 200);
    arrow.css("animation", "rotateArrow 0.2s forwards");
    thisObj.css('background','#cbcbcb');
  } else {
    content.animate({height: content.get(0).scrollHeight}, 300, function () {
      content.css("height", "auto");
      content.css("margin-bottom", "10px");
    });
    arrow.css("animation", "rotateArrowBack 0.2s forwards");
    thisObj.css('background','#e3e3e3');
  }
}
$(document).ready(function () {
  if($('.top-menu-intro-long-desc .top-menu-intro-view-more').length > 0) {
    $('.top-menu-intro-view-more-button').show();
  }else {
    $('.top-menu-intro-view-more-button').hide();
  }
});
function contractFilterView(thisObj) {
  let content = thisObj.find(".top-menu-intro-text").text();
  let arrow = thisObj.find(".filter-item-arrow");

  if (content === 'View More') {
    thisObj.find(".top-menu-intro-text").text('View Less');
    arrow.css("animation", "rotateArrowViewLess 0.2s forwards");
    $('.top-menu-intro-view-more').css('position','static');
  } else {
    thisObj.find(".top-menu-intro-text").text('View More');
    arrow.css("animation", "rotateArrowViewMore 0.2s forwards");
    $('.top-menu-intro-view-more').css('position','absolute');
  }
}
